import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-WorkPlacements-CreatePlacementModal', [
  'modal',
  'startDate',
  'agreementField',
  'notesInput',
  'nextButton',
  'backButton',
  'createButton',
  'editSummary',
  'contractEmployer',
  'contractContact',
  'contractDocumentLink',
  'summaryContractLink',
]);
